import { render, staticRenderFns } from "./ViewEditList.vue?vue&type=template&id=4ce37f16&"
import script from "./ViewEditList.vue?vue&type=script&lang=js&"
export * from "./ViewEditList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports